import { render, staticRenderFns } from "./ResourceContent.vue?vue&type=template&id=4f827024&scoped=true"
import script from "./ResourceContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourceContent.vue?vue&type=style&index=0&id=4f827024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f827024",
  null
  
)

export default component.exports